import gql from "graphql-tag";

export const CREATE_ZONE = gql`
  mutation AddZone($data: ZoneDataInput) {
    addZone(data: $data) {
      id
      name
      description
      values
      order
    }
  }
`;

export const UPDATE_ZONE = gql`
  mutation UpdateZone($where: ZoneWhereInput, $data: ZoneDataInput) {
    updateZone(where: $where, data: $data) {
      id
      name
      description
      values
      order
    }
  }
`;

export const DELETE_ZONE = gql`
  mutation DeleteZone($where: ZoneWhereInput) {
    deleteZone(where: $where) {
      id
    }
  }
`;

const zones = { CREATE_ZONE, UPDATE_ZONE, DELETE_ZONE };

export default zones;
